// import React, { useEffect, useRef, useState } from "react";
// import {
//   API_ENDPOINTS,
//   formatStringKey,
//   TERMS,
// } from "../../constant/_constant";
// import usePostRequest from "../../hooks/usePostRequest";
// import * as XLSX from "xlsx";
// import {
//   Form,
//   Table,
//   Card,
//   Row,
//   Col,
//   OverlayTrigger,
//   Tooltip,
//   Button,
//   InputGroup,
//   Accordion,
//   Toast,
// } from "react-bootstrap";
// import { pdf } from "@react-pdf/renderer";
// import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";
// import {
//   IconUserShare,
//   IconUserOff,
//   IconTrash,
//   IconCircle,
//   IconCircleCheckFilled,
//   IconUserCheck,
//   IconEdit,
//   IconCopy,
//   IconMailSpark,
//   IconMailForward,
//   IconUsers,
//   IconBuildings,
//   IconFileTypePdf,
//   IconHistory,
//   IconProgressCheck,
//   IconHistoryToggle,
//   IconFileTypeXls,
//   IconPaperclip,
//   IconFileSearch,
//   IconBox,
//   IconMessageCircle,
//   IconUserPin,
//   IconAddressBook,
//   IconMessage,
//   IconTriangle,
//   IconRotateClockwise,
//   IconBackspace,
//   IconSearch,
//   IconCalendarWeek,
//   IconEye,
// } from "@tabler/icons-react";
// import DynamicPagination from "../../components/DynamicPagination ";
// import useDebounce from "../../hooks/useDebounce";
// import moment from "moment";
// import { getAbbreviation } from "../../utils/_helpers";
// import { toast } from "react-toastify";
// import { MultiSelect } from "primereact/multiselect";
// import "primereact/resources/themes/lara-light-blue/theme.css";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import ConfirmationModal from "../../components/ConfirmationModal";
// import userp from "../../assets/user_avtar.svg";
// // import ActivateUser from "./ActivateUser";
// import { useSelector } from "react-redux";
// import { hasPermission } from "../../utils/_helpers";
// import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
// import PdfDocument from "./PDF/main";
// import SuccsessMsgModal from "../../components/SuccessMsgModal";
// import GetRmaHistoryPopup from "./GetRmaHistoryPopup";
// import View_DetailsRma from "./ViewDetail/View_DetailsRma";
// import ExcelDialogRma from "./ExcelDialogRma";
// import Lottie from "lottie-react";
// import WinData from "../../assets/won-status.json";
// import ReOpen from "./ReOpenPopup/ReOpen";
// import EmailHistoryOrder from "./Email/EmailHistoryOrder";
// import useIdleLogout from "../../hooks/useIdleLogout";

// const RmaListing = () => {
//   const [page, setPage] = useState({
//     created: 1,
//     investigation: 1,
//     resolution: 1,
//     followup: 1,
//     closed: 1,
//     cancelled: 1,
//   });
//   const [limit, setLimit] = useState(10);
//   const [rfqSku, setRfqSku] = useState("");
//   const [hasMoreCancelled, setHasMoreCancelled] = useState(true);
//   const [hasMoreResolution, setHasMoreResolution] = useState(true);
//   const [hasMoreCreated, setHasMoreCreated] = useState(true);
//   const [hasMoreInvestigation, setHasMoreInvestigation] = useState(true);
//   const [hasMoreClosed, setHasMoreClosed] = useState(true);
//   const [highlightedOrders, setHighlightedOrders] = useState([]);
//   const [hasMoreFollowup, setHasMoreFollowup] = useState(true);
//   const [isKOorCustomerDialogOpen, setIsKOorCustomerDialogOpen] =
//     React.useState(false);
//   const [search, setSearch] = useState("");
//   const navigate = useNavigate();
//   const [salesHeadFilter, setSalesHeadFilter] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState([]);
//   const [contractFilter, setContractFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [isInitialLoad, setIsInitialLoad] = useState(true); // runs once on mount

//   const [resolutionData, setResolutionData] = useState([]);
//   const [createdData, setCreatedData] = useState([]);
//   const [investigationData, setInvestigationData] = useState([]);
//   const [closedData, setClosedData] = useState([]);
//   const [followupData, setFollowupData] = useState([]);
//   const [cancelledData, setCancelledData] = useState([]);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [isSearchClicked, setIsSearchClicked] = useState(false);
//   const [activeStatuses, setActiveStatuses] = useState([]);
//   const [rmaId, setRmaId] = useState("");
//   const [show, setShow] = useState(false);
//   const [excelData, setExcelData] = useState([]);
//   const [currentStep, setCurrentStep] = useState(1);
//   const searchInputRef = useRef();
//   const [showReOpen, setShowReOpen] = useState(false);
//   const [selectedRmaId, setSelectedRmaId] = useState(null);
//   const [reopenedFilter, setReopenedFilter] = useState("NO");
//   const statusOptions = [
//     { label: "Created", value: "CREATED" },
//     { label: "Investigation", value: "INVESTIGATION" },
//     { label: "Resolution", value: "RESOLUTION" },
//     { label: "Follow Up", value: "FOLLOWUP" },
//     { label: "Closed", value: "CLOSED" },
//     { label: "Cancelled", value: "CANCELLED" },
//     { label: "ReOpened", value: "REOPENED" },
//   ];

//   const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
//     show: false,
//     message: "",
//     btntext: "Close",
//     title: "Succsess",
//   });

//   const [isModalOpen, setIsModalOpen] = useState({
//     show: false,
//   });
//   const [isHistoryOpen, setIsHistoryOpen] = useState({
//     show: false,
//   });

//   const [isExcelOpen, setIsExcelOpen] = useState({
//     show: false,
//   });

//   const [isEmaillOpen, setIsEmaillOpen] = useState({
//     title: "",
//     show: false,
//     row: "",
//     skuData: "",
//     defaultSubject: "",
//     Quote_No: "",
//     RFQID: "",
//     toEmail: "",
//     toName: "",
//   });

//   const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
//     show: false,
//     Quote_No: "",
//     rfq_id: "",
//   });

//   const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
//     show: false,
//     order_id: "",
//   });

//   const [isViewOpen, setIsViewOpen] = useState({
//     show: false,
//     products: [],
//     isStatusUpdate: false,
//   });

//   useIdleLogout();

//   const StatusList = [
//     "Investigation",
//     "Resolution",
//     "Follow Up",
//     "Closed",
//     "Created",
//     "Cancelled",
//   ];

//   const handleTabClick = (step) => {
//     setCurrentStep(step);
//   };

//   useEffect(() => {
//     setExcelData([
//       ...resolutionData,
//       ...createdData,
//       ...investigationData,
//       ...closedData,
//       ...followupData,
//     ]);
//   }, [
//     resolutionData,
//     createdData,
//     investigationData,
//     closedData,
//     followupData,
//   ]);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const user = useSelector((state) => state.auth.user);

//   const location = useLocation();

//   const triggerCardHighlight = (rma_id) => {
//     setHighlightedOrders((prev) => [...prev, rma_id]);
//     setTimeout(() => {
//       setHighlightedOrders((prev) => prev.filter((id) => id !== rma_id));
//     }, 3000);
//   };

//   // useEffect(() => {
//   //   const params = new URLSearchParams(location.search);
//   //   const viewOpportunityId = params.get("viewOpportunityId");

//   //   if (viewOpportunityId) {
//   //     const allOpportunities = [
//   //       ...draftData,
//   //       ...pendingData,
//   //       ...cancelledData,
//   //       ...wonData,
//   //       ...lostData,
//   //     ];

//   //     const matchedOrder = allOpportunities.find(
//   //       (opportunity) => String(opportunity.rfq_id) === viewOpportunityId
//   //     );

//   //     if (matchedOrder) {
//   //       setIsViewOpen({
//   //         show: true,
//   //         products: matchedOrder,
//   //         isStatusUpdate: false,
//   //       });
//   //     }
//   //   }
//   // }, [
//   //   location.search,
//   //   draftData,
//   //   pendingData,
//   //   cancelledData,
//   //   wonData,
//   //   lostData,
//   // ]);

//   // check perminssion
//   const hasPermission = (permissionArray, permissionType) =>
//     permissionArray.includes(permissionType);

//   const userAssignRole = user?.permissions?.manage_role || [];
//   const canDeleteUser = hasPermission(userAssignRole, "delete");
//   const canAssignRole = hasPermission(userAssignRole, "write");
//   // check perminssion

//   // const { postData: fetchOpportunity, data } = usePostRequest(
//   //   API_ENDPOINTS.LISTING_OPPORTUNITIES
//   // );

//   const { loadingdownLoad, postData: DownLoadFile } = usePostRequest(
//     API_ENDPOINTS.DownLoadFile
//   );

//   const {
//     data: resolutionres,
//     loadingResolution,
//     postData: fetchRmaResolution,
//   } = usePostRequest(API_ENDPOINTS.RMA_LIST);
//   const {
//     data: followupres,
//     loadingFollowup,
//     postData: fetchRmaFollowup,
//   } = usePostRequest(API_ENDPOINTS.RMA_LIST);
//   const {
//     data: createdres,
//     loadingCreated,
//     postData: fetchRmaCreated,
//   } = usePostRequest(API_ENDPOINTS.RMA_LIST);
//   const {
//     data: investigationres,
//     loadingInvestigation,
//     postData: fetchRmaInvestigation,
//   } = usePostRequest(API_ENDPOINTS.RMA_LIST);
//   const {
//     data: closedres,
//     loadingClosed,
//     postData: fetchRmaClosed,
//   } = usePostRequest(API_ENDPOINTS.RMA_LIST);
//   const {
//     data: cancelledres,
//     loadingCancelled,
//     postData: fetchRmaCancelled,
//   } = usePostRequest(API_ENDPOINTS.RMA_LIST);
//   const {
//     data: contractData,
//     isLoading,
//     postData: fetchContract,
//   } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

//   const { data: SalesHead, postData: fetchRfq } = usePostRequest(
//     API_ENDPOINTS.GET_RFQ_USERS
//   );

//   // const { debounceSearch } = useDebounce(search);

//   const handleGenerateExcel = (selectedFields) => {
//     try {
//       if (!excelData || excelData?.length === 0) {
//         throw new Error("No data available to export");
//       }
//       if (!selectedFields || selectedFields.length === 0) {
//         throw new Error("No fields selected for export");
//       }

//       const formattedData = excelData?.map((row, index) => {
//         const filteredRow = {};
//         selectedFields.forEach((field) => {
//           switch (field) {
//             case "Order ID":
//               filteredRow[field] = row.order_id || "";
//               break;
//             case "RMA ID":
//               filteredRow[field] = row.rma_id || "";
//               break;
//             case "Manufacturer RMA ID":
//               filteredRow[field] = row.manufacturer_id || "";
//               break;
//             case "Date Reported":
//               filteredRow[field] = row.published_date
//                 ? moment(row.published_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Estimated Return Date":
//               filteredRow[field] = row.estimated_date
//                 ? moment(row.estimated_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Actual Return Date":
//               filteredRow[field] = row.actual_date
//                 ? moment(row.actual_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "RMA Description":
//               filteredRow[field] = row.brief;
//               break;
//             case "Tracking Number":
//               filteredRow[field] = row.tracking_number || "";
//               break;
//             case "Organization Name":
//               filteredRow[field] = row.organization_name;
//               break;

//             case "Customer Name":
//               filteredRow[field] = row.rmaKo.name;
//               break;
//             case "Customer Email":
//               filteredRow[field] = row.rmaKo.email;
//               break;
//             case "Customer Phone":
//               filteredRow[field] = row.rmaKo.phone;
//               break;
//             case "Customer Address":
//               filteredRow[field] = row.rmaKo.address;
//               break;
//             case "Shipping Method":
//               filteredRow[field] = row.shipping_method;
//               break;
//             case "Shipper Name":
//               filteredRow[field] = row.rmaShipping.name;
//               break;
//             case "Shipper Email":
//               filteredRow[field] = row.rmaShipping.email;
//               break;
//             case "Shipper Phone":
//               filteredRow[field] = row.rmaShipping.phone;
//               break;
//             case "Shipper Address":
//               filteredRow[field] = row.rmaShipping.address;
//               break;

//             case "Total Cost Before Margin($)":
//               filteredRow[field] = row.total_cost_before_margin;
//               break;
//             case "Total Cost After Margin($)":
//               filteredRow[field] = row.total_cost_after_margin;
//               break;
//             case "Created Date":
//               filteredRow[field] = row.created_at
//                 ? moment(row.created_at).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Last Updated Date":
//               filteredRow[field] = row.updated_at
//                 ? moment(row.updated_at).format("MM/DD/YYYY")
//                 : "";
//               break;
//             default:
//               filteredRow[field] = "";
//               break;
//           }
//         });
//         return filteredRow;
//       });

//       if (formattedData.length === 0) {
//         throw new Error("No valid data to export");
//       }

//       const wb = XLSX.utils.book_new();
//       const ws = XLSX.utils.json_to_sheet(formattedData);

//       XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
//       const today = new Date();
//       const excelFileName =
//         "ASPETTO SALES-" + String(today).split("T")[0] + ".xlsx";
//       XLSX.writeFile(wb, excelFileName);
//       console.log("Excel file generated successfully");
//     } catch (error) {
//       console.error("Error generating Excel file:", error.message);
//       alert(error.message);
//     }
//   };

//   const stickyRef = useRef(null);
//   const [isFixed, setIsFixed] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (stickyRef.current) {
//         const offsetTop = stickyRef.current.offsetTop;
//         setIsFixed(window.scrollY > offsetTop);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const PD = new Date();
//   const today = new Intl.DateTimeFormat("en-US", {
//     dateStyle: "medium",
//   }).format(PD);

//   const HandlePDFClick = async (row) => {
//     // const OP_arr = String(`${row.order_id}`).split(".");
//     const OP_arr = String(`RMA`).split(".");
//     for (var i = 0; i < OP_arr.length; i++) {
//       OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
//     }

//     const updatedInvoiceData = {
//       // ...InvoiceData,
//       rma_id: row.rma_id,
//       invoice_num: String(row.invoice_no),
//       Customer_Name: row.rmaKo?.name ? row.rmaKo.name : "N/A",
//       Customer_Email: row.rmaKo.email ? row.rmaKo.email : "N/A",
//       Customer_Phone: row.rmaKo.phone ? row.rmaKo.phone : "N/A",
//       Customer_Address: row.rmaKo.address ? row.rmaKo.address : "N/A",
//       Print_Date: String(today),
//       trans_date: String(row.updated_at).split("T")[0],
//       // due_date: row.due_date,
//       estimated_date: row.estimated_date ? row.estimated_date : "N/A",
//       // Valid_For: row.valid_for,
//       Address:
//         "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
//       Shipper_Name: row.rmaShipping?.name ? row.rmaShipping?.name : "N/A",
//       Shipper_Email: row.rmaShipping?.email ? row.rmaShipping?.email : "N/A",
//       Shipper_Phone: row.rmaShipping?.phone ? row.rmaShipping?.phone : "N/A",
//       Shipper_Address: row.rmaShipping?.address
//         ? row.rmaShipping?.address
//         : "N/A",
//       items: row.RmaProducts,
//       Total_Cost: row.total_cost_after_margin
//         ? row.total_cost_after_margin
//         : "",
//       BillTo_Phone: row.orderBilling?.phone ? row.orderBilling.phone : "N/A",
//       BillTo_Name: row.orderBilling?.name ? row.orderBilling.name : "N/A",
//       BillTo_Address: row.orderBilling?.address
//         ? row.orderBilling.address
//         : "N/A",
//       BillTo_Email: row.orderBilling?.email ? row.orderBilling.email : "N/A",
//       // Notes: row.RfqNotes,
//       Shipping_Details: {
//         Organization_Name: row?.organization_name
//           ? row.organization_name
//           : "N/A",
//         KO_name: row.rmaKo?.name ? row.rmaKo.name : "N/A",
//         Sales_Head_Info: {
//           Name: row.sales_lead_name ? row.sales_lead_name : "",
//           Email: row.sales_lead_email ? row.sales_lead_email : "",
//           Phone: row.sales_lead_phone ? row.sales_lead_phone : "",
//         },
//         Customer_Name: row.rmaShipping.name ? row.rmaShipping.name : "N/A",
//         Customer_Email: row.rmaShipping.email ? row.rmaShipping.email : "N/A",
//         Customer_Phone: row.rmaShipping.phone ? row.rmaShipping.phone : "N/A",
//         Customer_Address: row.rmaShipping.address
//           ? row.rmaShipping.address
//           : "N/A",
//         Shipping_Method: row.shipping_method ? row.shipping_method : "N/A",
//         Shipping_Terms: row.shipping_term ? row.shipping_term : "N/A",
//         Estimated_Delivery: row.estimated_delivery
//           ? row.estimated_delivery
//           : "N/A",
//         Payment_Terms: row.payment_term ? row.payment_term : "N/A",
//       },
//     };

//     // setInvoiceData(updatedInvoiceData);
//     //  Format Opportunity Name for file name
//     let File_Opportunity_Name = "";

//     File_Opportunity_Name = OP_arr.join(" ");

//     setTimeout(async () => {
//       // setLoading(true);
//       const pdfBlob = await pdf(
//         <PdfDocument invoicedata={updatedInvoiceData} />
//       ).toBlob();

//       const url = URL.createObjectURL(pdfBlob);

//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `${File_Opportunity_Name} ${
//         String(row.rma_id).split(".")[0]
//       }.pdf`;
//       document.body.appendChild(a);
//       console.log("2", a.download);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
//     }, 0);
//   };

//   const handleSearch = () => {
//     setActiveStatuses([]);
//     const searchValue = searchInputRef.current.value?.trim();
//     // Check if only one of the dates is selected
//     if ((startDate && !endDate) || (!startDate && endDate)) {
//       toast.warning("Please select both the dates.");
//       return;
//     }

//     // Reset pages for all statuses
//     setPage(() => ({
//       created: 1,
//       investigation: 1,
//       resolution: 1,
//       followup: 1,
//       closed: 1,
//     }));

//     setSearch(searchValue);
//     setIsInitialLoad(false);
//     setIsSearchClicked(true);
//   };

//   const handleClearFilter = (e) => {
//     setSalesHeadFilter("");
//     setContractFilter("");
//     setStatusFilter("");
//     setSelectedStatus([]);
//     setSearch("");
//     setStartDate(null);
//     setEndDate(null);
//     setReopenedFilter("NO");

//     setPage(() => ({
//       created: 1,
//       investigation: 1,
//       followup: 1,
//       closed: 1,
//       resolution: 1,
//     }));

//     // Trigger dependency so the original data is fetched again
//     setIsInitialLoad(true);
//     setIsSearchClicked(true);
//   };

//   const onSuccessfulFetchRmaCancelled = (response, reset = false) => {
//     if (response?.data.length < limit) {
//       setHasMoreCancelled(false);
//     }

//     setCancelledData((prevData) => {
//       const combined = reset
//         ? response?.data
//         : [...prevData, ...response?.data];
//       const unique = Array.from(
//         new Map(combined.map((item) => [item.rma_id, item])).values()
//       );
//       return unique;
//     });
//   };

//   const onSuccessfulFetchRmaResolution = (response, reset = false) => {
//     if (response?.data.length < limit) {
//       setHasMoreResolution(false);
//     }

//     setResolutionData((prevData) => {
//       const combined = reset
//         ? response?.data
//         : [...prevData, ...response?.data];
//       const unique = Array.from(
//         new Map(combined.map((item) => [item.rma_id, item])).values()
//       );
//       return unique;
//     });
//   };

//   const onSuccessfulFetchRmaCreated = (response, reset = false) => {
//     if (response?.data.length < limit) {
//       setHasMoreCreated(false);
//     }
//     setCreatedData((prevData) => {
//       const combined = reset
//         ? response?.data
//         : [...prevData, ...response?.data];
//       const unique = Array.from(
//         new Map(combined.map((item) => [item.rma_id, item])).values()
//       );
//       return unique;
//     });
//   };
//   const onSuccessfulFetchRmaInvestigation = (response, reset = false) => {
//     if (response?.data.length < limit) {
//       setHasMoreInvestigation(false);
//     }

//     setInvestigationData((prevData) => {
//       const combined = reset
//         ? response?.data
//         : [...prevData, ...response?.data];
//       const unique = Array.from(
//         new Map(combined.map((item) => [item.rma_id, item])).values()
//       );
//       return unique;
//     });
//   };

//   const onSuccessfulFetchRmaClosed = (response, reset = false) => {
//     if (response?.data.length < limit) {
//       setHasMoreClosed(false);
//     }

//     setClosedData((prevData) => {
//       const combined = reset
//         ? response?.data
//         : [...prevData, ...response?.data];
//       const unique = Array.from(
//         new Map(combined.map((item) => [item.rma_id, item])).values()
//       );
//       return unique;
//     });
//   };

//   const onSuccessfulFetchRmaFollowup = (response, reset = false) => {
//     if (response?.data.length < limit) {
//       setHasMoreFollowup(false);
//     }

//     setFollowupData((prevData) => {
//       const combined = reset
//         ? response?.data
//         : [...prevData, ...response?.data];
//       const unique = Array.from(
//         new Map(combined.map((item) => [item.rma_id, item])).values()
//       );
//       return unique;
//     });
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       await fetchRfq({ module_type: "RFQ" });
//       await fetchContract();
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const isPagination = page.cancelled > 1;
//     const shouldFetch =
//       isInitialLoad ||
//       isPagination ||
//       (isSearchClicked &&
//         (selectedStatus.length === 0 || selectedStatus.includes("CANCELLED")));
//     if (!shouldFetch) return;
//     setHasMoreCancelled(true); // Reset hasMore on filter/search change

//     fetchRmaCancelled(
//       {
//         page: page.cancelled,
//         limit,
//         status: "CANCELLED",
//         created_date_from: startDate
//           ? moment(startDate).format("YYYY-MM-DD")
//           : undefined,
//         created_date_to: endDate
//           ? moment(endDate).format("YYYY-MM-DD")
//           : undefined,
//         search: search?.length > 0 ? search : undefined,
//         reopened: reopenedFilter,
//       },
//       (response) =>
//         onSuccessfulFetchRmaCancelled(response, page.cancelled === 1),
//       setActiveStatuses((prev) =>
//         prev.includes("CANCELLED") ? prev : [...prev, "CANCELLED"]
//       )
//     );
//     setIsSearchClicked(false);
//   }, [page.cancelled, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

//   useEffect(() => {
//     const isPagination = page.resolution > 1;
//     const shouldFetch =
//       isInitialLoad ||
//       isPagination ||
//       (isSearchClicked &&
//         (selectedStatus.length === 0 || selectedStatus.includes("RESOLUTION")));
//     if (!shouldFetch) return;
//     setHasMoreResolution(true); // Reset hasMore on filter/search change

//     fetchRmaResolution(
//       {
//         page: page.resolution,
//         limit,
//         status: "RESOLUTION",
//         created_date_from: startDate
//           ? moment(startDate).format("YYYY-MM-DD")
//           : undefined,
//         created_date_to: endDate
//           ? moment(endDate).format("YYYY-MM-DD")
//           : undefined,
//         search: search?.length > 0 ? search : undefined,
//         reopened: reopenedFilter,
//       },
//       (response) =>
//         onSuccessfulFetchRmaResolution(response, page.resolution === 1),
//       setActiveStatuses((prev) =>
//         prev.includes("RESOLUTION") ? prev : [...prev, "RESOLUTION"]
//       )
//     );
//     setIsSearchClicked(false);
//   }, [page.resolution, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

//   useEffect(() => {
//     const isPagination = page.created > 1;
//     const shouldFetch =
//       isInitialLoad ||
//       isPagination ||
//       (isSearchClicked &&
//         (selectedStatus.length === 0 || selectedStatus.includes("CREATED")));
//     if (!shouldFetch) return;

//     setHasMoreCreated(true); // Correct: this is for DRAFT data

//     fetchRmaCreated(
//       {
//         page: page.created,
//         limit,
//         status: "CREATED",
//         created_date_from: startDate
//           ? moment(startDate).format("YYYY-MM-DD")
//           : undefined,
//         created_date_to: endDate
//           ? moment(endDate).format("YYYY-MM-DD")
//           : undefined,
//         search: search?.length > 0 ? search : undefined,
//         reopened: reopenedFilter,
//       },
//       (response) => onSuccessfulFetchRmaCreated(response, page.created === 1),
//       setActiveStatuses((prev) =>
//         prev.includes("CREATED") ? prev : [...prev, "CREATED"]
//       )
//     );
//     setIsSearchClicked(false);
//   }, [page.created, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

//   useEffect(() => {
//     const isPagination = page.investigation > 1;
//     const shouldFetch =
//       isInitialLoad ||
//       isPagination ||
//       (isSearchClicked &&
//         (selectedStatus.length === 0 ||
//           selectedStatus.includes("INVESTIGATION")));
//     if (!shouldFetch) return;
//     setHasMoreInvestigation(true); // Reset hasMore on new search/filter

//     fetchRmaInvestigation(
//       {
//         page: page.investigation,
//         limit,
//         status: "INVESTIGATION",
//         created_date_from: startDate
//           ? moment(startDate).format("YYYY-MM-DD")
//           : undefined,
//         created_date_to: endDate
//           ? moment(endDate).format("YYYY-MM-DD")
//           : undefined,
//         search: search?.length > 0 ? search : undefined,
//         reopened: reopenedFilter,
//       },
//       (response) =>
//         onSuccessfulFetchRmaInvestigation(response, page.investigation === 1),
//       setActiveStatuses((prev) =>
//         prev.includes("INVESTIGATION") ? prev : [...prev, "INVESTIGATION"]
//       )
//     );
//     setIsSearchClicked(false);
//   }, [page.investigation, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

//   useEffect(() => {
//     const isPagination = page.closed > 1;
//     const shouldFetch =
//       isInitialLoad ||
//       isPagination ||
//       (isSearchClicked &&
//         (selectedStatus.length === 0 || selectedStatus.includes("CLOSED")));
//     if (!shouldFetch) return;
//     setHasMoreClosed(true); // Reset hasMore on new search/filter

//     fetchRmaClosed(
//       {
//         page: page.closed,
//         limit,
//         status: "CLOSED",
//         created_date_from: startDate
//           ? moment(startDate).format("YYYY-MM-DD")
//           : undefined,
//         created_date_to: endDate
//           ? moment(endDate).format("YYYY-MM-DD")
//           : undefined,
//         search: search?.length > 0 ? search : undefined,
//         reopened: reopenedFilter,
//       },
//       (response) => onSuccessfulFetchRmaClosed(response, page.closed === 1),
//       setActiveStatuses((prev) =>
//         prev.includes("CLOSED") ? prev : [...prev, "CLOSED"]
//       )
//     );
//     setIsSearchClicked(false);
//   }, [page.closed, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

//   useEffect(() => {
//     const isPagination = page.followup > 1;
//     const shouldFetch =
//       isInitialLoad ||
//       isPagination ||
//       (isSearchClicked &&
//         (selectedStatus.length === 0 || selectedStatus.includes("FOLLOWUP")));
//     if (!shouldFetch) return;
//     setHasMoreFollowup(true);

//     fetchRmaFollowup(
//       {
//         page: page.followup,
//         limit,
//         status: "FOLLOWUP",
//         created_date_from: startDate
//           ? moment(startDate).format("YYYY-MM-DD")
//           : undefined,
//         created_date_to: endDate
//           ? moment(endDate).format("YYYY-MM-DD")
//           : undefined,
//         search: search?.length > 0 ? search : undefined,
//         reopened: reopenedFilter,
//       },
//       (response) => onSuccessfulFetchRmaFollowup(response, page.followup === 1),
//       setActiveStatuses((prev) =>
//         prev.includes("FOLLOWUP") ? prev : [...prev, "FOLLOWUP"]
//       )
//     );
//     setIsSearchClicked(false);
//   }, [page.followup, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

//   const handleLoadMoreResolution = () => {
//     if (hasMoreResolution) {
//       setPage((prev) => ({
//         ...prev,
//         resolution: prev.resolution + 1,
//       }));
//     }
//   };

//   const handleLoadMoreCreated = () => {
//     if (hasMoreCreated) {
//       setPage((prev) => ({
//         ...prev,
//         created: prev.created + 1,
//       }));
//     }
//   };

//   const handleLoadMoreInvestigation = () => {
//     if (hasMoreInvestigation) {
//       setPage((prev) => ({
//         ...prev,
//         investigation: prev.investigation + 1,
//       }));
//     }
//   };

//   const handleLoadMoreClosed = () => {
//     if (hasMoreClosed) {
//       setPage((prev) => ({
//         ...prev,
//         closed: prev.closed + 1,
//       }));
//     }
//   };

//   const handleLoadMoreFollowUp = () => {
//     if (hasMoreFollowup) {
//       setPage((prev) => ({
//         ...prev,
//         followup: prev.followup + 1,
//       }));
//     }
//   };

//   const handleLoadMoreCancelled = () => {
//     if (hasMoreCancelled) {
//       setPage((prev) => ({
//         ...prev,
//         cancelled: prev.cancelled + 1,
//       }));
//     }
//   };

//   const statusCounts = {
//     Investigation: investigationres?.pagination?.totalRmas || 0,
//     Resolution: resolutionres?.pagination?.totalRmas || 0,
//     FollowUp: followupres?.pagination?.totalRmas || 0,
//     Closed: closedres?.pagination?.totalRmas || 0,
//     Created: createdres?.pagination?.totalRmas || 0,
//     Cancelled: cancelledres?.pagination?.totalRmas || 0,
//   };

//   const handleRMARVERSION_OPEN = (e, rma) => {
//     e.preventDefault();
//     setRmaId(rma);
//     setIsHistoryOpen({ show: true });
//   };

//   const handleViewClick = (row) => {
//     setIsViewOpen({
//       show: true,
//       products: row,
//     });

//     const currentUrl = window.location.pathname;
//     const newUrl = `${currentUrl}?${row.rma_id}`;
//     window.history.pushState(null, "", newUrl);
//   };

//   const showReOpenPopup = (rmaId) => {
//     setSelectedRmaId(rmaId);
//     setShowReOpen(true);
//   };

//   return (
//     <>
//       <ReOpen
//         show={showReOpen}
//         onClose={() => setShowReOpen(false)}
//         rmaId={selectedRmaId}
//         onConfirm={handleClearFilter}
//       />

//       {isHistoryOpen.show && (
//         <GetRmaHistoryPopup
//           rmaId={rmaId}
//           show={isHistoryOpen.show}
//           setShow={setIsHistoryOpen}
//         />
//       )}

//       {isEmailHistoryOpen.show && (
//         <EmailHistoryOrder
//           username={user.username}
//           show={isEmailHistoryOpen.show}
//           rma_id={isEmailHistoryOpen.order_id}
//           setShow={setIsEmailHistoryOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}

//       <View_DetailsRma
//         isStatusUpdate={isViewOpen.isStatusUpdate}
//         onStatusUpdate={() =>
//           setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
//         }
//         triggerCardHighlight={triggerCardHighlight}
//       />

//       {isExcelOpen.show && (
//         <ExcelDialogRma
//           show={isExcelOpen.show}
//           setShow={setIsExcelOpen}
//           onDownload={(fields) => {
//             handleGenerateExcel(fields);
//             setIsExcelOpen({ show: false });
//           }}
//         />
//       )}

//       <div className="page-header d-print-none">
//         <div className="row g-2 align-items-center">
//           <div className="col">
//             <h2 className="page-title">RMAs</h2>
//           </div>
//         </div>
//       </div>

//       <Card className="mb-3">
//         <Card.Body>
//           <Form
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 e.preventDefault();
//                 handleSearch();
//               }
//             }}
//           >
//             <Row>
//               <Col md={2} className="mb-2">
//                 <Form.Label className="form-label">Search</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconSearch />
//                   </InputGroup.Text>
//                   <Form.Control
//                     ref={searchInputRef}
//                     type="text"
//                     placeholder="Search..."
//                     name="name"
//                     autoComplete="off"
//                     value={search}
//                     onChange={(e) => setSearch(e.target.value)}
//                     // onKeyDown={(e) => {
//                     //   if (e.key === "Enter") {
//                     //     e.preventDefault();
//                     //     handleSearch();
//                     //   }
//                     // }}
//                   />
//                 </InputGroup>
//               </Col>

//               <Col md={2} className="mb-2">
//                 <label className="form-label">Select Status</label>
//                 <MultiSelect
//                   value={selectedStatus}
//                   options={statusOptions}
//                   onChange={(e) => {
//                     setSelectedStatus(e.value);
//                   }}
//                   optionLabel="label"
//                   placeholder="All"
//                   display="chip"
//                   className="w-100"
//                   panelHeaderTemplate={() => null}
//                 />
//               </Col>

//               <Col md={2}>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="">ReOpened</Form.Label>
//                   <InputGroup>
//                     <Form.Select
//                       value={reopenedFilter}
//                       onChange={(e) => setReopenedFilter(e.target.value)}
//                     >
//                       <option value="NO">No</option>
//                       <option value="YES">Yes</option>
//                     </Form.Select>
//                   </InputGroup>
//                 </Form.Group>
//               </Col>

//               <Col md={4} className="mb-2">
//                 <div className="d-flex gap-2">
//                   <div className="w-100">
//                     <Form.Label className="form-label">
//                       Created Date From
//                     </Form.Label>
//                     <InputGroup>
//                       <InputGroup.Text>
//                         <IconCalendarWeek />
//                       </InputGroup.Text>
//                       <DatePicker
//                         className="form-control"
//                         selected={startDate}
//                         placeholderText="Select Date"
//                         onChange={(date) => setStartDate(date)}
//                         selectsStart
//                         startDate={startDate}
//                         endDate={endDate}
//                         showMonthDropdown
//                         showYearDropdown
//                         // minDate={new Date()}
//                       />
//                     </InputGroup>
//                   </div>

//                   <div className="w-100">
//                     <Form.Label className="form-label">
//                       Created Date To
//                     </Form.Label>
//                     <InputGroup>
//                       <InputGroup.Text>
//                         <IconCalendarWeek />
//                       </InputGroup.Text>
//                       <DatePicker
//                         className="form-control"
//                         selected={endDate}
//                         placeholderText="Select Date"
//                         onChange={(date) => setEndDate(date)}
//                         selectsEnd
//                         startDate={startDate}
//                         endDate={endDate}
//                         minDate={startDate}
//                         showMonthDropdown
//                         showYearDropdown
//                       />
//                     </InputGroup>
//                   </div>
//                 </div>
//               </Col>
//               <Col md={3} className="mb-2">
//                 {/* <Form.Label className="form-label">&nbsp;</Form.Label> */}
//                 <div className="d-flex gap-2">
//                   <Button
//                     className="w-100"
//                     variant="warning"
//                     onClick={handleSearch}
//                   >
//                     Apply Filters
//                   </Button>
//                   <Button
//                     className="w-100"
//                     variant="outline-secondary"
//                     onClick={handleClearFilter}
//                   >
//                     Clear Filters
//                   </Button>
//                   <Button
//                     style={{ minWidth: "auto" }}
//                     onClick={() => setIsExcelOpen({ show: true })}
//                     variant="outline-success"
//                   >
//                     <IconFileTypeXls /> Download
//                   </Button>
//                 </div>
//               </Col>
//               <Form.Text>
//                 Search by rma ID, customer information, tracking number or any
//                 other relevant keyword.
//               </Form.Text>
//             </Row>
//           </Form>
//         </Card.Body>
//       </Card>

//       <>
//         <div className="scroll_status">
//           <div
//             className={`status_row_sticky d-none d-md-block  ${
//               isFixed ? "is-fixed" : ""
//             }`}
//             ref={stickyRef}
//           >
//             {(isInitialLoad || activeStatuses.includes("CREATED")) && (
//               <div className="status_item_box draft_status">
//                 <div className="status-heading">
//                   <IconCircle size={18} stroke={5} color="#818183ff" />
//                   <span className="fw-bold">Created</span>
//                 </div>
//                 <span className="status_count" style={{ color: "#818183ff" }}>
//                   {createdres?.pagination?.totalRmas}
//                 </span>
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("INVESTIGATION")) && (
//               <div className="status_item_box pending_status">
//                 <div className="status-heading">
//                   <IconCircle size={18} stroke={5} color="#f1a008ff" />
//                   <span className="fw-bold">Investigation</span>
//                 </div>
//                 <span className="status_count" style={{ color: "#f1a008ff" }}>
//                   {investigationres?.pagination?.totalRmas}
//                 </span>
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("RESOLUTION")) && (
//               <div className="status_item_box draft_status">
//                 <div className="status-heading">
//                   <IconCircle size={18} stroke={5} color="#0b68c080" />
//                   <span className="fw-bold">Resolution</span>
//                 </div>
//                 <span className="status_count" style={{ color: "#0b68c080" }}>
//                   {resolutionres?.pagination?.totalRmas}
//                 </span>
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("FOLLOWUP")) && (
//               <div className="status_item_box progress_status">
//                 <div className="status-heading">
//                   <IconCircle size={18} stroke={5} color="#9606b9ff" />
//                   <span className="fw-bold">Follow Up</span>
//                 </div>
//                 <span className="status_count" style={{ color: "#9606b9ff" }}>
//                   {followupres?.pagination?.totalRmas}
//                 </span>
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("CLOSED")) && (
//               <div className="status_item_box won_status">
//                 <div className="status-heading">
//                   <IconCircle size={18} stroke={5} color="#06a159ff" />
//                   <span className="fw-bold">Closed</span>
//                 </div>
//                 <span className="status_count" style={{ color: "#06a159ff" }}>
//                   {closedres?.pagination?.totalRmas}
//                 </span>
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("CANCELLED")) && (
//               <div className="status_item_box closed_status">
//                 <div className="status-heading">
//                   <IconCircle size={18} stroke={5} color="#e72222" />
//                   <span className="fw-bold">Cancelled</span>
//                 </div>
//                 <span className="status_count" style={{ color: "#e72222" }}>
//                   {cancelledres?.pagination?.totalRmas}
//                 </span>
//               </div>
//             )}
//           </div>

//           <div
//             className="stepper_status bs-stepper-header d-flex d-md-none"
//             role="tablist"
//           >
//             {StatusList.map((step, idx) => (
//               <div
//                 className={`step ${
//                   currentStep === idx + 1
//                     ? " active"
//                     : idx + 1 < currentStep
//                     ? "completed"
//                     : ""
//                 }`}
//                 key={idx}
//               >
//                 <button
//                   onClick={() => handleTabClick(idx + 1)}
//                   type="button"
//                   className="step-trigger"
//                   role="tab"
//                 >
//                   <span className="bs-stepper-label d-flex align-items-center justify-content-between">
//                     {step}
//                     <span className="status_count ms-2">
//                       {statusCounts[step] ?? 0}
//                     </span>
//                   </span>
//                 </button>
//               </div>
//             ))}
//           </div>

//           <div className="status_row_box">
//             {(isInitialLoad || activeStatuses.includes("CREATED")) && (
//               <div
//                 className={`status_row_scroll ${
//                   currentStep === 5 ? "active_status_tab" : ""
//                 }  Created`}
//               >
//                 <>
//                   {createdData?.length > 0 ? (
//                     createdData?.map((row, index) => (
//                       <Card
//                         // className="status_item_card"
//                         className={`status_item_card  ${
//                           highlightedOrders.includes(row.rma_id)
//                             ? "card-highlight "
//                             : ""
//                         }`}
//                         key={index}
//                         onClick={() => handleViewClick(row)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <Card.Body>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card d-flex gap-2 align-items-center">
//                                 RMA ID:{" "}
//                                 <p className="label_card listing_label">
//                                   {row.rma_id}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">Order ID</div>
//                               <p className="label_card">
//                                 {row?.order_id || "N/A"}
//                               </p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">
//                                 Organization Name
//                               </div>
//                               <p className="label_card">
//                                 {row?.organization_name || "N/A"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">RMA Type</div>
//                               <p className="label_card">{row?.rma_type}</p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">Created Date</div>
//                               <p className="label_card">
//                                 {moment(row?.created_at).format("MM/DD/YYYY")}
//                               </p>
//                             </div>
//                           </div>

//                           <div className="button-groups">
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(row);
//                                 }}
//                               >
//                                 <IconEye size={24} />
//                               </span>
//                               <b> View Details </b>
//                             </div>
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleRMARVERSION_OPEN(e, row.rma_id);
//                                 }}
//                               >
//                                 <IconHistoryToggle size={24} />
//                               </span>
//                               <b> Changes History</b>
//                             </div>

//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setIsEmailHistoryOpen({
//                                     show: true,
//                                     order_id: row.rma_id,
//                                   });
//                                 }}
//                               >
//                                 <IconMailSpark size={24} />
//                               </span>
//                               <b>Email</b>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row mt-3 justify-content-center">
//                             <div className="total_amt_rfq">
//                               <strong>Total Cost:</strong>
//                               <strong className="amt_bold">
//                                 ${row?.total_cost_after_margin}
//                               </strong>
//                             </div>
//                           </div>
//                           <div className="ftr_card_box">
//                             <a
//                               className="big_badge bg-cyan-lt"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(`/edit-rma/${row.rma_id}`);
//                               }}
//                             >
//                               <IconEdit width={18} height={18} /> Edit
//                             </a>
//                             <div className="rfq_lis_short">
//                               <span>
//                                 <IconBox stroke={1} />
//                                 {row.RmaProducts.length}
//                               </span>
//                               <span>
//                                 <IconPaperclip stroke={1} />
//                                 {row.Attachments.length}
//                               </span>
//                               <span>
//                                 <IconMessageCircle stroke={1} />
//                                 {row.section.reduce((acc, section) => {
//                                   return acc + section.notes.length;
//                                 }, 0)}
//                               </span>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     ))
//                   ) : (
//                     <Card className="status_item_card">
//                       <Card.Body>No data found.</Card.Body>
//                     </Card>
//                   )}
//                 </>

//                 {createdres?.data?.length >= 10 && hasMoreCreated && (
//                   <div className="text-center mt-2">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={handleLoadMoreCreated}
//                       disabled={loadingCreated}
//                     >
//                       <IconRotateClockwise size={18} />
//                       {loadingCreated ? "Loading..." : "Load More"}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("INVESTIGATION")) && (
//               <div
//                 className={`status_row_scroll ${
//                   currentStep === 1 ? "active_status_tab" : ""
//                 }  Investigation`}
//               >
//                 <>
//                   {investigationData?.length > 0 ? (
//                     investigationData?.map((row, index) => (
//                       <Card
//                         // className="status_item_card"
//                         className={`status_item_card  ${
//                           highlightedOrders.includes(row.rma_id)
//                             ? "card-highlight "
//                             : ""
//                         }`}
//                         key={index}
//                         onClick={() => handleViewClick(row)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <Card.Body>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card d-flex gap-2 align-items-center">
//                                 RMA ID:{" "}
//                                 <p className="label_card listing_label">
//                                   {row.rma_id}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">Order ID</div>
//                               <p className="label_card">
//                                 {row?.order_id || "N/A"}
//                               </p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">
//                                 Organization Name
//                               </div>
//                               <p className="label_card">
//                                 {row?.organization_name || "N/A"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">RMA Type</div>
//                               <p className="label_card">{row?.rma_type}</p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">Created Date</div>
//                               <p className="label_card">
//                                 {moment(row?.created_at).format("MM/DD/YYYY")}
//                               </p>
//                             </div>
//                           </div>

//                           <div className="button-groups">
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(row);
//                                 }}
//                               >
//                                 <IconEye size={24} />
//                               </span>
//                               <b> View Details </b>
//                             </div>
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleRMARVERSION_OPEN(e, row.rma_id);
//                                 }}
//                               >
//                                 <IconHistoryToggle size={24} />
//                               </span>
//                               <b> Changes History</b>
//                             </div>

//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setIsEmailHistoryOpen({
//                                     show: true,
//                                     order_id: row.rma_id,
//                                   });
//                                 }}
//                               >
//                                 <IconMailSpark size={24} />
//                               </span>
//                               <b>Email</b>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row mt-3 justify-content-center">
//                             <div className="total_amt_rfq">
//                               <strong>Total Cost:</strong>
//                               <strong className="amt_bold">
//                                 ${row?.total_cost_after_margin || "0.00"}
//                               </strong>
//                             </div>
//                           </div>
//                           <div className="ftr_card_box">
//                             <a
//                               className="big_badge bg-cyan-lt"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(`/edit-rma/${row.rma_id}`);
//                               }}
//                             >
//                               <IconEdit width={18} height={18} /> Edit
//                             </a>
//                             <div className="rfq_lis_short">
//                               <span>
//                                 <IconBox stroke={1} />
//                                 {row.RmaProducts.length}
//                               </span>
//                               <span>
//                                 <IconPaperclip stroke={1} />
//                                 {row.Attachments.length}
//                               </span>
//                               <span>
//                                 <IconMessageCircle stroke={1} />
//                                 {row.section.reduce((acc, section) => {
//                                   return acc + section.notes.length;
//                                 }, 0)}
//                               </span>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     ))
//                   ) : (
//                     <Card className="status_item_card">
//                       <Card.Body>No data found.</Card.Body>
//                     </Card>
//                   )}
//                 </>
//                 {investigationres?.data?.length >= 10 &&
//                   hasMoreInvestigation && (
//                     <div className="text-center mt-2">
//                       <button
//                         className="btn btn-outline-primary"
//                         onClick={handleLoadMoreInvestigation}
//                         disabled={loadingInvestigation}
//                       >
//                         <IconRotateClockwise size={18} />
//                         {loadingInvestigation ? "Loading..." : "Load More"}
//                       </button>
//                     </div>
//                   )}
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("RESOLUTION")) && (
//               <div
//                 className={`status_row_scroll ${
//                   currentStep === 2 ? "active_status_tab" : ""
//                 }  Resolution`}
//               >
//                 <>
//                   {resolutionData?.length > 0 ? (
//                     resolutionData?.map((row, index) => (
//                       <Card
//                         // className="status_item_card"
//                         className={`status_item_card  ${
//                           highlightedOrders.includes(row.rma_id)
//                             ? "card-highlight "
//                             : ""
//                         }`}
//                         key={index}
//                         onClick={() => handleViewClick(row)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <Card.Body>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card d-flex gap-2 align-items-center">
//                                 RMA ID:{" "}
//                                 <p className="label_card listing_label">
//                                   {row.rma_id}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">Order ID</div>
//                               <p className="label_card">
//                                 {row?.order_id || "N/A"}
//                               </p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">
//                                 Organization Name
//                               </div>
//                               <p className="label_card">
//                                 {row?.organization_name || "N/A"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">RMA Type</div>
//                               <p className="label_card">{row?.rma_type}</p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">Created Date</div>
//                               <p className="label_card">
//                                 {moment(row?.created_at).format("MM/DD/YYYY")}
//                               </p>
//                             </div>
//                           </div>

//                           <div className="button-groups">
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(row);
//                                 }}
//                               >
//                                 <IconEye size={24} />
//                               </span>
//                               <b> View Details </b>
//                             </div>
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleRMARVERSION_OPEN(e, row.rma_id);
//                                 }}
//                               >
//                                 <IconHistoryToggle size={24} />
//                               </span>
//                               <b> Changes History</b>
//                             </div>

//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setIsEmailHistoryOpen({
//                                     show: true,
//                                     order_id: row.rma_id,
//                                   });
//                                 }}
//                               >
//                                 <IconMailSpark size={24} />
//                               </span>
//                               <b>Email</b>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row mt-3 justify-content-center">
//                             <div className="total_amt_rfq">
//                               <strong>Total Cost:</strong>
//                               <strong className="amt_bold">
//                                 ${row?.total_cost_after_margin || "0.00"}
//                               </strong>
//                             </div>
//                           </div>
//                           <div className="ftr_card_box">
//                             <a
//                               className="big_badge bg-cyan-lt"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(`/edit-rma/${row.rma_id}`);
//                               }}
//                             >
//                               <IconEdit width={18} height={18} /> Edit
//                             </a>
//                             <div className="rfq_lis_short">
//                               <span>
//                                 <IconBox stroke={1} />
//                                 {row.RmaProducts.length}
//                               </span>
//                               <span>
//                                 <IconPaperclip stroke={1} />
//                                 {row.Attachments.length}
//                               </span>
//                               <span>
//                                 <IconMessageCircle stroke={1} />
//                                 {row.section.reduce((acc, section) => {
//                                   return acc + section.notes.length;
//                                 }, 0)}
//                               </span>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     ))
//                   ) : (
//                     <Card className="status_item_card">
//                       <Card.Body>No data found.</Card.Body>
//                     </Card>
//                   )}
//                 </>

//                 {resolutionres?.data?.length >= 10 && hasMoreResolution && (
//                   <div className="text-center mt-2">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={handleLoadMoreResolution}
//                       disabled={loadingResolution}
//                     >
//                       <IconRotateClockwise size={18} />
//                       {loadingResolution ? "Loading..." : "Load More"}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("FOLLOWUP")) && (
//               <div
//                 className={`status_row_scroll ${
//                   currentStep === 3 ? "active_status_tab" : ""
//                 }  Follow Up`}
//               >
//                 <>
//                   {followupData?.length > 0 ? (
//                     followupData?.map((row, index) => (
//                       <Card
//                         // className="status_item_card"
//                         className={`status_item_card  ${
//                           highlightedOrders.includes(row.rma_id)
//                             ? "card-highlight "
//                             : ""
//                         }`}
//                         key={index}
//                         onClick={() => handleViewClick(row)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <Card.Body>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card d-flex gap-2 align-items-center">
//                                 RMA ID:{" "}
//                                 <p className="label_card listing_label">
//                                   {row.rma_id}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">Order ID</div>
//                               <p className="label_card">
//                                 {row?.order_id || "N/A"}
//                               </p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">
//                                 Organization Name
//                               </div>
//                               <p className="label_card">
//                                 {row?.organization_name || "N/A"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">RMA Type</div>
//                               <p className="label_card">{row?.rma_type}</p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">Created Date</div>
//                               <p className="label_card">
//                                 {moment(row?.created_at).format("MM/DD/YYYY")}
//                               </p>
//                             </div>
//                           </div>

//                           <div className="button-groups">
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(row);
//                                 }}
//                               >
//                                 <IconEye size={24} />
//                               </span>
//                               <b> View Details </b>
//                             </div>
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleRMARVERSION_OPEN(e, row.rma_id);
//                                 }}
//                               >
//                                 <IconHistoryToggle size={24} />
//                               </span>
//                               <b> Changes History</b>
//                             </div>

//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setIsEmailHistoryOpen({
//                                     show: true,
//                                     order_id: row.rma_id,
//                                   });
//                                 }}
//                               >
//                                 <IconMailSpark size={24} />
//                               </span>
//                               <b>Email</b>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row mt-3 justify-content-center">
//                             <div className="total_amt_rfq">
//                               <strong>Total Cost:</strong>
//                               <strong className="amt_bold">
//                                 ${row?.total_cost_after_margin || "0.00"}
//                               </strong>
//                             </div>
//                           </div>
//                           <div className="ftr_card_box">
//                             <a
//                               className="big_badge bg-cyan-lt"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(`/edit-rma/${row.rma_id}`);
//                               }}
//                             >
//                               <IconEdit width={18} height={18} /> Edit
//                             </a>
//                             <div className="rfq_lis_short">
//                               <span>
//                                 <IconBox stroke={1} />
//                                 {row.RmaProducts.length}
//                               </span>
//                               <span>
//                                 <IconPaperclip stroke={1} />
//                                 {row.Attachments.length}
//                               </span>
//                               <span>
//                                 <IconMessageCircle stroke={1} />
//                                 {row.section.reduce((acc, section) => {
//                                   return acc + section.notes.length;
//                                 }, 0)}
//                               </span>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     ))
//                   ) : (
//                     <Card className="status_item_card">
//                       <Card.Body>No data found.</Card.Body>
//                     </Card>
//                   )}
//                 </>

//                 {followupres?.data?.length >= 10 && hasMoreFollowup && (
//                   <div className="text-center mt-2">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={handleLoadMoreFollowUp}
//                       disabled={loadingFollowup}
//                     >
//                       <IconRotateClockwise size={18} />
//                       {loadingFollowup ? "Loading..." : "Load More"}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("CLOSED")) && (
//               <div
//                 className={`status_row_scroll ${
//                   currentStep === 4 ? "active_status_tab" : ""
//                 }  Closed`}
//               >
//                 <>
//                   {closedData?.length > 0 ? (
//                     closedData?.map((row, index) => (
//                       <Card
//                         // className="status_item_card"
//                         className={`status_item_card  ${
//                           highlightedOrders.includes(row.rma_id)
//                             ? "card-highlight "
//                             : ""
//                         }`}
//                         key={index}
//                         onClick={() => handleViewClick(row)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <Card.Body>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card d-flex gap-2 align-items-center">
//                                 RMA ID:{" "}
//                                 <p className="label_card listing_label">
//                                   {row.rma_id}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">Order ID</div>
//                               <p className="label_card">
//                                 {row?.order_id || "N/A"}
//                               </p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">
//                                 Organization Name
//                               </div>
//                               <p className="label_card">
//                                 {row?.organization_name || "N/A"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">RMA Type</div>
//                               <p className="label_card">{row?.rma_type}</p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">Created Date</div>
//                               <p className="label_card">
//                                 {moment(row?.created_at).format("MM/DD/YYYY")}
//                               </p>
//                             </div>
//                           </div>

//                           <div className="button-groups">
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(row);
//                                 }}
//                               >
//                                 <IconEye size={24} />
//                               </span>
//                               <b> View Details </b>
//                             </div>
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleRMARVERSION_OPEN(e, row.rma_id);
//                                 }}
//                               >
//                                 <IconHistoryToggle size={24} />
//                               </span>
//                               <b> Changes History</b>
//                             </div>

//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setIsEmailHistoryOpen({
//                                     show: true,
//                                     order_id: row.rma_id,
//                                   });
//                                 }}
//                               >
//                                 <IconMailSpark size={24} />
//                               </span>
//                               <b>Email</b>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row mt-3 justify-content-center">
//                             <div className="total_amt_rfq">
//                               <strong>Total Cost:</strong>
//                               <strong className="amt_bold">
//                                 ${row?.total_cost_after_margin || "0.00"}
//                               </strong>
//                             </div>
//                           </div>
//                           <div className="ftr_card_box">
//                             {row?.reopened_status === "N" ? (
//                               <a
//                                 className="big_badge bg-cyan-lt"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   showReOpenPopup(row.rma_id);
//                                   // navigate(`/edit-rma/${row.rma_id}`);
//                                 }}
//                               >
//                                 <IconEdit width={18} height={18} /> ReOpen
//                               </a>
//                             ) : (
//                               <a
//                                 className="big_badge bg-cyan-lt"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   navigate(`/edit-rma/${row.rma_id}`);
//                                 }}
//                               >
//                                 <IconEdit width={18} height={18} /> Edit
//                               </a>
//                             )}
//                             {/* <a
//                               className="big_badge bg-cyan-lt"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(`/edit-rma/${row.rma_id}`);
//                               }}
//                             >
//                               <IconEdit width={18} height={18} /> Edit
//                             </a> */}
//                             <div className="rfq_lis_short">
//                               <span>
//                                 <IconBox stroke={1} />
//                                 {row.RmaProducts.length}
//                               </span>
//                               <span>
//                                 <IconPaperclip stroke={1} />
//                                 {row.Attachments.length}
//                               </span>
//                               <span>
//                                 <IconMessageCircle stroke={1} />
//                                 {row.section.reduce((acc, section) => {
//                                   return acc + section.notes.length;
//                                 }, 0)}
//                               </span>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     ))
//                   ) : (
//                     <Card className="status_item_card">
//                       <Card.Body>No data found.</Card.Body>
//                     </Card>
//                   )}
//                 </>

//                 {closedres?.data?.length >= 10 && hasMoreClosed && (
//                   <div className="text-center mt-2">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={handleLoadMoreClosed}
//                       disabled={loadingClosed}
//                     >
//                       <IconRotateClockwise size={18} />
//                       {loadingClosed ? "Loading..." : "Load More"}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}

//             {(isInitialLoad || activeStatuses.includes("CANCELLED")) && (
//               <div
//                 className={`status_row_scroll ${
//                   currentStep === 4 ? "active_status_tab" : ""
//                 }  Cancelled`}
//               >
//                 <>
//                   {cancelledData?.length > 0 ? (
//                     cancelledData?.map((row, index) => (
//                       <Card
//                         // className="status_item_card"
//                         className={`status_item_card  ${
//                           highlightedOrders.includes(row.rma_id)
//                             ? "card-highlight "
//                             : ""
//                         }`}
//                         key={index}
//                         onClick={() => handleViewClick(row)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <Card.Body>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card d-flex gap-2 align-items-center">
//                                 RMA ID:{" "}
//                                 <p className="label_card listing_label">
//                                   {row.rma_id}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">Order ID</div>
//                               <p className="label_card">
//                                 {row?.order_id || "N/A"}
//                               </p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">
//                                 Organization Name
//                               </div>
//                               <p className="label_card">
//                                 {row?.organization_name || "N/A"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row">
//                             <div className="rfq_item_card">
//                               <div className="value_card">RMA Type</div>
//                               <p className="label_card">{row?.rma_type}</p>
//                             </div>
//                             <div className="rfq_item_card">
//                               <div className="value_card">Created Date</div>
//                               <p className="label_card">
//                                 {moment(row?.created_at).format("MM/DD/YYYY")}
//                               </p>
//                             </div>
//                           </div>

//                           <div className="button-groups">
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(row);
//                                 }}
//                               >
//                                 <IconEye size={24} />
//                               </span>
//                               <b> View Details </b>
//                             </div>
//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleRMARVERSION_OPEN(e, row.rma_id);
//                                 }}
//                               >
//                                 <IconHistoryToggle size={24} />
//                               </span>
//                               <b> Changes History</b>
//                             </div>

//                             <div className="badge_btn">
//                               <span
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setIsEmailHistoryOpen({
//                                     show: true,
//                                     order_id: row.rma_id,
//                                   });
//                                 }}
//                               >
//                                 <IconMailSpark size={24} />
//                               </span>
//                               <b>Email</b>
//                             </div>
//                           </div>
//                           <div className="rfq_card_row mt-3 justify-content-center">
//                             <div className="total_amt_rfq">
//                               <strong>Total Cost:</strong>
//                               <strong className="amt_bold">
//                                 ${row?.total_cost_after_margin || "0.00"}
//                               </strong>
//                             </div>
//                           </div>
//                           <div className="ftr_card_box">
//                             {row?.reopened_status === "N" ? (
//                               <a
//                                 className="big_badge bg-cyan-lt"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   showReOpenPopup(row.rma_id);
//                                   // navigate(`/edit-rma/${row.rma_id}`);
//                                 }}
//                               >
//                                 <IconEdit width={18} height={18} /> ReOpen
//                               </a>
//                             ) : (
//                               <a
//                                 className="big_badge bg-cyan-lt"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   navigate(`/edit-rma/${row.rma_id}`);
//                                 }}
//                               >
//                                 <IconEdit width={18} height={18} /> Edit
//                               </a>
//                             )}
//                             {/* <a
//                               className="big_badge bg-cyan-lt"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(`/edit-rma/${row.rma_id}`);
//                               }}
//                             >
//                               <IconEdit width={18} height={18} /> Edit
//                             </a> */}
//                             <div className="rfq_lis_short">
//                               <span>
//                                 <IconBox stroke={1} />
//                                 {row.RmaProducts.length}
//                               </span>
//                               <span>
//                                 <IconPaperclip stroke={1} />
//                                 {row.Attachments.length}
//                               </span>
//                               <span>
//                                 <IconMessageCircle stroke={1} />
//                                 {row.section.reduce((acc, section) => {
//                                   return acc + section.notes.length;
//                                 }, 0)}
//                               </span>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     ))
//                   ) : (
//                     <Card className="status_item_card">
//                       <Card.Body>No data found.</Card.Body>
//                     </Card>
//                   )}
//                 </>

//                 {cancelledres?.data?.length >= 10 && hasMoreCancelled && (
//                   <div className="text-center mt-2">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={handleLoadMoreCancelled}
//                       disabled={loadingCancelled}
//                     >
//                       <IconRotateClockwise size={18} />
//                       {loadingCancelled ? "Loading..." : "Load More"}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </>
//     </>
//   );
// };

// export default RmaListing;

import React, { useEffect, useRef, useState } from "react";
import {
  API_ENDPOINTS,
  formatStringKey,
  TERMS,
} from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import * as XLSX from "xlsx";
import {
  Form,
  Table,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
  InputGroup,
  Accordion,
  Toast,
} from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import {
  IconUserShare,
  IconUserOff,
  IconTrash,
  IconCircle,
  IconCircleCheckFilled,
  IconUserCheck,
  IconEdit,
  IconCopy,
  IconMailSpark,
  IconMailForward,
  IconUsers,
  IconBuildings,
  IconFileTypePdf,
  IconHistory,
  IconProgressCheck,
  IconHistoryToggle,
  IconFileTypeXls,
  IconPaperclip,
  IconFileSearch,
  IconBox,
  IconMessageCircle,
  IconUserPin,
  IconAddressBook,
  IconMessage,
  IconTriangle,
  IconRotateClockwise,
  IconBackspace,
  IconSearch,
  IconCalendarWeek,
  IconEye,
  IconRefreshDot,
  IconSquareArrowRight,
} from "@tabler/icons-react";
import DynamicPagination from "../../components/DynamicPagination ";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { getAbbreviation } from "../../utils/_helpers";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import ConfirmationModal from "../../components/ConfirmationModal";
import userp from "../../assets/user_avtar.svg";
// import ActivateUser from "./ActivateUser";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/_helpers";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import PdfDocument from "./PDF/main";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import GetRmaHistoryPopup from "./GetRmaHistoryPopup";
import View_DetailsRma from "./ViewDetail/View_DetailsRma";
import ExcelDialogRma from "./ExcelDialogRma";
import Lottie from "lottie-react";
import WinData from "../../assets/won-status.json";
import EmailHistoryOrder from "./Email/EmailHistoryOrder";
import useIdleLogout from "../../hooks/useIdleLogout";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";

const RmaListing = () => {
  const [page, setPage] = useState({
    created: 1,
    open: 1,
    closed: 1,
    cancelled: 1,
  });
  const [limit, setLimit] = useState(10);
  const [rfqSku, setRfqSku] = useState("");
  const [hasMoreCancelled, setHasMoreCancelled] = useState(true);
  const [hasMoreCreated, setHasMoreCreated] = useState(true);
  const [hasMoreOpen, setHasMoreOpen] = useState(true);
  const [hasMoreClosed, setHasMoreClosed] = useState(true);
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [isKOorCustomerDialogOpen, setIsKOorCustomerDialogOpen] =
    React.useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [salesHeadFilter, setSalesHeadFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [contractFilter, setContractFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true); // runs once on mount

  const [createdData, setCreatedData] = useState([]);
  const [openData, setOpenData] = useState([]);
  const [closedData, setClosedData] = useState([]);
  const [cancelledData, setCancelledData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [activeStatuses, setActiveStatuses] = useState([]);
  const [rmaId, setRmaId] = useState("");
  const [show, setShow] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const searchInputRef = useRef();
  const [reopenedFilter, setReopenedFilter] = useState("NO");
  const statusOptions = [
    { label: "Pending", value: "CREATED" },
    { label: "Active/Open", value: "OPEN" },
    { label: "Closed", value: "CLOSED" },
    { label: "Cancelled", value: "CANCELLED" },
  ];

  const [isModalStatusOpen, setIsModalStatusOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
  });
  const [isHistoryOpen, setIsHistoryOpen] = useState({
    show: false,
  });

  const [isExcelOpen, setIsExcelOpen] = useState({
    show: false,
  });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    RFQID: "",
    toEmail: "",
    toName: "",
  });

  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    rfq_id: "",
  });

  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    order_id: "",
  });

  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    products: [],
    isStatusUpdate: false,
  });

  useIdleLogout();

  const StatusList = ["Created", "Open", "Closed", "Cancelled"];

  const handleTabClick = (step) => {
    setCurrentStep(step);
  };

  useEffect(() => {
    setExcelData([...createdData, ...openData, ...closedData]);
  }, [createdData, openData, closedData]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = useSelector((state) => state.auth.user);

  const location = useLocation();

  const triggerCardHighlight = (rma_id) => {
    setHighlightedOrders((prev) => [...prev, rma_id]);
    setTimeout(() => {
      setHighlightedOrders((prev) => prev.filter((id) => id !== rma_id));
    }, 3000);
  };

  // check perminssion
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  const userAssignRole = user?.permissions?.manage_role || [];
  const canDeleteUser = hasPermission(userAssignRole, "delete");
  const canAssignRole = hasPermission(userAssignRole, "write");
  // check perminssion

  const { loadingdownLoad, postData: DownLoadFile } = usePostRequest(
    API_ENDPOINTS.DownLoadFile,
  );

  const {
    data: createdres,
    loadingCreated,
    postData: fetchRmaCreated,
  } = usePostRequest(API_ENDPOINTS.RMA_LIST);
  const {
    data: openres,
    loadingOpen,
    postData: fetchRmaOpen,
  } = usePostRequest(API_ENDPOINTS.RMA_LIST);
  const {
    data: closedres,
    loadingClosed,
    postData: fetchRmaClosed,
  } = usePostRequest(API_ENDPOINTS.RMA_LIST);
  const {
    data: cancelledres,
    loadingCancelled,
    postData: fetchRmaCancelled,
  } = usePostRequest(API_ENDPOINTS.RMA_LIST);
  const {
    data: contractData,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { data: SalesHead, postData: fetchRfq } = usePostRequest(
    API_ENDPOINTS.GET_RFQ_USERS,
  );
  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.RMA_STATUS,
  );

  const handleGenerateExcel = (selectedFields) => {
    try {
      if (!excelData || excelData?.length === 0) {
        throw new Error("No data available to export");
      }
      if (!selectedFields || selectedFields.length === 0) {
        throw new Error("No fields selected for export");
      }

      const formattedData = excelData?.map((row, index) => {
        const filteredRow = {};
        selectedFields.forEach((field) => {
          switch (field) {
            case "Order ID":
              filteredRow[field] = row.order_id || "";
              break;
            case "RMA ID":
              filteredRow[field] = row.rma_id || "";
              break;
            case "Manufacturer RMA ID":
              filteredRow[field] = row.manufacturer_id || "";
              break;
            case "Date Reported":
              filteredRow[field] = row.published_date
                ? moment(row.published_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Estimated Return Date":
              filteredRow[field] = row.estimated_date
                ? moment(row.estimated_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Actual Return Date":
              filteredRow[field] = row.actual_date
                ? moment(row.actual_date).format("MM/DD/YYYY")
                : "";
              break;
            case "RMA Description":
              filteredRow[field] = row.brief;
              break;
            case "Tracking Number":
              filteredRow[field] = row.tracking_number || "";
              break;
            case "Organization Name":
              filteredRow[field] = row.organization_name;
              break;

            case "Customer Name":
              filteredRow[field] = row.rmaKo.name;
              break;
            case "Customer Email":
              filteredRow[field] = row.rmaKo.email;
              break;
            case "Customer Phone":
              filteredRow[field] = row.rmaKo.phone;
              break;
            case "Customer Address":
              filteredRow[field] = row.rmaKo.address;
              break;
            case "Shipping Method":
              filteredRow[field] = row.shipping_method;
              break;
            case "Shipper Name":
              filteredRow[field] = row.rmaShipping.name;
              break;
            case "Shipper Email":
              filteredRow[field] = row.rmaShipping.email;
              break;
            case "Shipper Phone":
              filteredRow[field] = row.rmaShipping.phone;
              break;
            case "Shipper Address":
              filteredRow[field] = row.rmaShipping.address;
              break;

            case "Total Cost Before Margin($)":
              filteredRow[field] = row.total_cost_before_margin;
              break;
            case "Total Cost After Margin($)":
              filteredRow[field] = row.total_cost_after_margin;
              break;
            case "Created Date":
              filteredRow[field] = row.created_at
                ? moment(row.created_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Last Updated Date":
              filteredRow[field] = row.updated_at
                ? moment(row.updated_at).format("MM/DD/YYYY")
                : "";
              break;
            default:
              filteredRow[field] = "";
              break;
          }
        });
        return filteredRow;
      });

      if (formattedData.length === 0) {
        throw new Error("No valid data to export");
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);

      XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
      const today = new Date();
      const excelFileName =
        "ASPETTO SALES-" + String(today).split("T")[0] + ".xlsx";
      XLSX.writeFile(wb, excelFileName);
      console.log("Excel file generated successfully");
    } catch (error) {
      console.error("Error generating Excel file:", error.message);
      alert(error.message);
    }
  };

  const stickyRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (stickyRef.current) {
        const offsetTop = stickyRef.current.offsetTop;
        setIsFixed(window.scrollY > offsetTop);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);

  const HandlePDFClick = async (row) => {
    const OP_arr = String(`RMA`).split(".");
    for (var i = 0; i < OP_arr.length; i++) {
      OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
    }

    const updatedInvoiceData = {
      rma_id: row.rma_id,
      invoice_num: String(row.invoice_no),
      Customer_Name: row.rmaKo?.name ? row.rmaKo.name : "N/A",
      Customer_Email: row.rmaKo.email ? row.rmaKo.email : "N/A",
      Customer_Phone: row.rmaKo.phone ? row.rmaKo.phone : "N/A",
      Customer_Address: row.rmaKo.address ? row.rmaKo.address : "N/A",
      Print_Date: String(today),
      trans_date: String(row.updated_at).split("T")[0],
      estimated_date: row.estimated_date ? row.estimated_date : "N/A",
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      Shipper_Name: row.rmaShipping?.name ? row.rmaShipping?.name : "N/A",
      Shipper_Email: row.rmaShipping?.email ? row.rmaShipping?.email : "N/A",
      Shipper_Phone: row.rmaShipping?.phone ? row.rmaShipping?.phone : "N/A",
      Shipper_Address: row.rmaShipping?.address
        ? row.rmaShipping?.address
        : "N/A",
      items: row.RmaProducts,
      Total_Cost: row.total_cost_after_margin
        ? row.total_cost_after_margin
        : "",
      BillTo_Phone: row.orderBilling?.phone ? row.orderBilling.phone : "N/A",
      BillTo_Name: row.orderBilling?.name ? row.orderBilling.name : "N/A",
      BillTo_Address: row.orderBilling?.address
        ? row.orderBilling.address
        : "N/A",
      BillTo_Email: row.orderBilling?.email ? row.orderBilling.email : "N/A",
      Shipping_Details: {
        Organization_Name: row?.organization_name
          ? row.organization_name
          : "N/A",
        KO_name: row.rmaKo?.name ? row.rmaKo.name : "N/A",
        Sales_Head_Info: {
          Name: row.sales_lead_name ? row.sales_lead_name : "",
          Email: row.sales_lead_email ? row.sales_lead_email : "",
          Phone: row.sales_lead_phone ? row.sales_lead_phone : "",
        },
        Customer_Name: row.rmaShipping.name ? row.rmaShipping.name : "N/A",
        Customer_Email: row.rmaShipping.email ? row.rmaShipping.email : "N/A",
        Customer_Phone: row.rmaShipping.phone ? row.rmaShipping.phone : "N/A",
        Customer_Address: row.rmaShipping.address
          ? row.rmaShipping.address
          : "N/A",
        Shipping_Method: row.shipping_method ? row.shipping_method : "N/A",
        Shipping_Terms: row.shipping_term ? row.shipping_term : "N/A",
        Estimated_Delivery: row.estimated_delivery
          ? row.estimated_delivery
          : "N/A",
        Payment_Terms: row.payment_term ? row.payment_term : "N/A",
      },
    };

    let File_Opportunity_Name = "";

    File_Opportunity_Name = OP_arr.join(" ");

    setTimeout(async () => {
      const pdfBlob = await pdf(
        <PdfDocument invoicedata={updatedInvoiceData} />,
      ).toBlob();

      const url = URL.createObjectURL(pdfBlob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${File_Opportunity_Name} ${
        String(row.rma_id).split(".")[0]
      }.pdf`;
      document.body.appendChild(a);
      console.log("2", a.download);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  };

  const handleSearch = () => {
    setActiveStatuses([]);
    const searchValue = searchInputRef.current.value?.trim();
    // Check if only one of the dates is selected
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }

    // Reset pages for all statuses
    setPage(() => ({
      created: 1,
      open: 1,
      closed: 1,
      cancelled: 1,
    }));

    setSearch(searchValue);
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  };

  const handleClearFilter = (e) => {
    setSalesHeadFilter("");
    setContractFilter("");
    setStatusFilter("");
    setSelectedStatus([]);
    setSearch("");
    setStartDate(null);
    setEndDate(null);
    setReopenedFilter("NO");

    setPage(() => ({
      created: 1,
      open: 1,
      closed: 1,
      cancelled: 1,
    }));

    // Trigger dependency so the original data is fetched again
    setIsInitialLoad(true);
    setIsSearchClicked(true);
  };

  const onSuccessfulFetchRmaCancelled = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreCancelled(false);
    }

    setCancelledData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.rma_id, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchRmaCreated = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreCreated(false);
    }
    setCreatedData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.rma_id, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchRmaOpen = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreOpen(false);
    }

    setOpenData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.rma_id, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchRmaClosed = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreClosed(false);
    }

    setClosedData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.rma_id, item])).values(),
      );
      return unique;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchRfq({ module_type: "RFQ" });
      await fetchContract();
    };

    fetchData();
  }, []);

  useEffect(() => {
    const isPagination = page.cancelled > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("CANCELLED")));
    if (!shouldFetch) return;
    setHasMoreCancelled(true); // Reset hasMore on filter/search change

    fetchRmaCancelled(
      {
        page: page.cancelled,
        limit,
        status: "CANCELLED",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        reopened: reopenedFilter,
      },
      (response) =>
        onSuccessfulFetchRmaCancelled(response, page.cancelled === 1),
      setActiveStatuses((prev) =>
        prev.includes("CANCELLED") ? prev : [...prev, "CANCELLED"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.cancelled, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.created > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("CREATED")));
    if (!shouldFetch) return;

    setHasMoreCreated(true);

    fetchRmaCreated(
      {
        page: page.created,
        limit,
        status: "CREATED",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        reopened: reopenedFilter,
      },
      (response) => onSuccessfulFetchRmaCreated(response, page.created === 1),
      setActiveStatuses((prev) =>
        prev.includes("CREATED") ? prev : [...prev, "CREATED"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.created, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.open > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("OPEN")));
    if (!shouldFetch) return;
    setHasMoreOpen(true); // Reset hasMore on new search/filter

    fetchRmaOpen(
      {
        page: page.open,
        limit,
        status: "OPEN",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        reopened: reopenedFilter,
      },
      (response) => onSuccessfulFetchRmaOpen(response, page.open === 1),
      setActiveStatuses((prev) =>
        prev.includes("OPEN") ? prev : [...prev, "OPEN"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.open, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.closed > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("CLOSED")));
    if (!shouldFetch) return;
    setHasMoreClosed(true); // Reset hasMore on new search/filter

    fetchRmaClosed(
      {
        page: page.closed,
        limit,
        status: "CLOSED",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        reopened: reopenedFilter,
      },
      (response) => onSuccessfulFetchRmaClosed(response, page.closed === 1),
      setActiveStatuses((prev) =>
        prev.includes("CLOSED") ? prev : [...prev, "CLOSED"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.closed, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  const handleLoadMoreCreated = () => {
    if (hasMoreCreated) {
      setPage((prev) => ({
        ...prev,
        created: prev.created + 1,
      }));
    }
  };

  const handleLoadMoreOpen = () => {
    if (hasMoreOpen) {
      setPage((prev) => ({
        ...prev,
        open: prev.open + 1,
      }));
    }
  };

  const handleLoadMoreClosed = () => {
    if (hasMoreClosed) {
      setPage((prev) => ({
        ...prev,
        closed: prev.closed + 1,
      }));
    }
  };

  const handleLoadMoreCancelled = () => {
    if (hasMoreCancelled) {
      setPage((prev) => ({
        ...prev,
        cancelled: prev.cancelled + 1,
      }));
    }
  };

  const statusCounts = {
    Created: createdres?.pagination?.totalRmas || 0,
    Open: openres?.pagination?.totalRmas || 0,
    Closed: closedres?.pagination?.totalRmas || 0,
    Cancelled: cancelledres?.pagination?.totalRmas || 0,
  };

  const handleRMARVERSION_OPEN = (e, rma) => {
    e.preventDefault();
    setRmaId(rma);
    setIsHistoryOpen({ show: true });
  };

  const handleViewClick = (row) => {
    setIsViewOpen({
      show: true,
      products: row,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row.rma_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const ChangeStatusHandler = (rmaId, status) => {
    statusChange(
      { rma_id: rmaId, rma_status: status },
      onStatusSuccess,
      onStatusError,
    );
  };

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    triggerCardHighlight(response?.rma_id);
    handleClose();
    handleClearFilter();
  };

  const onStatusError = (error) => {
    console.log("error?.products?.length", error?.products?.length);
    toast.error(error.message || "An error occurred during Status Change.");
  };

  const openModal = (rmaId, status, Old_Status) => {
    let modalMessage = `Are you sure you want to change status to "${Old_Status} to ${status}"`;
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(rmaId, status);
    };
    let action = "Change";
    setIsModalStatusOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  return (
    <>
      <ComanConfirmationModal
        show={isModalStatusOpen.show}
        onHide={() => {
          setIsModalStatusOpen({ ...isModalStatusOpen, show: false });
          // setIsOpen(false);
        }}
        title={isModalStatusOpen.title}
        message={isModalStatusOpen.message}
        onConfirm={isModalStatusOpen.onConfirm}
        icon={isModalStatusOpen.icon}
        type={isModalStatusOpen.type}
      />

      {isHistoryOpen.show && (
        <GetRmaHistoryPopup
          rmaId={rmaId}
          show={isHistoryOpen.show}
          setShow={setIsHistoryOpen}
        />
      )}

      {isEmailHistoryOpen.show && (
        <EmailHistoryOrder
          username={user.username}
          show={isEmailHistoryOpen.show}
          rma_id={isEmailHistoryOpen.order_id}
          setShow={setIsEmailHistoryOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      <View_DetailsRma
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
        triggerCardHighlight={triggerCardHighlight}
      />

      {isExcelOpen.show && (
        <ExcelDialogRma
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={(fields) => {
            handleGenerateExcel(fields);
            setIsExcelOpen({ show: false });
          }}
        />
      )}

      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">RMAs</h2>
          </div>
        </div>
      </div>

      <Card className="mb-3">
        <Card.Body>
          <Form
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          >
            <Row>
              <Col md={2} className="mb-2">
                <Form.Label className="form-label">Search</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconSearch />
                  </InputGroup.Text>
                  <Form.Control
                    ref={searchInputRef}
                    type="text"
                    placeholder="Search..."
                    name="name"
                    autoComplete="off"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>
              </Col>

              <Col md={2} className="mb-2">
                <label className="form-label">Select Status</label>
                <MultiSelect
                  value={selectedStatus}
                  options={statusOptions}
                  onChange={(e) => {
                    setSelectedStatus(e.value);
                  }}
                  optionLabel="label"
                  placeholder="All"
                  display="chip"
                  className="w-100"
                  panelHeaderTemplate={() => null}
                />
              </Col>

              {/* <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label className="">ReOpened</Form.Label>
                  <InputGroup>
                    <Form.Select
                      value={reopenedFilter}
                      onChange={(e) => setReopenedFilter(e.target.value)}
                    >
                      <option value="NO">No</option>
                      <option value="YES">Yes</option>
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </Col> */}

              <Col md={4} className="mb-2">
                <div className="d-flex gap-2">
                  <div className="w-100">
                    <Form.Label className="form-label">
                      Created Date From
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconCalendarWeek />
                      </InputGroup.Text>
                      <DatePicker
                        className="form-control"
                        selected={startDate}
                        placeholderText="Select Date"
                        onChange={(date) => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        showMonthDropdown
                        showYearDropdown
                      />
                    </InputGroup>
                  </div>

                  <div className="w-100">
                    <Form.Label className="form-label">
                      Created Date To
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconCalendarWeek />
                      </InputGroup.Text>
                      <DatePicker
                        className="form-control"
                        selected={endDate}
                        placeholderText="Select Date"
                        onChange={(date) => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        showMonthDropdown
                        showYearDropdown
                      />
                    </InputGroup>
                  </div>
                </div>
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label className="form-label">&nbsp;</Form.Label>
                <div className="d-flex gap-2">
                  <Button
                    className="w-100"
                    variant="warning"
                    onClick={handleSearch}
                  >
                    Apply Filters
                  </Button>
                  <Button
                    className="w-100"
                    variant="outline-secondary"
                    onClick={handleClearFilter}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    style={{ minWidth: "auto" }}
                    onClick={() => setIsExcelOpen({ show: true })}
                    variant="outline-success"
                  >
                    <IconFileTypeXls /> Download
                  </Button>
                </div>
              </Col>
              <Form.Text>
                Search by rma ID, customer information, tracking number or any
                other relevant keyword.
              </Form.Text>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <>
        <div className="scroll_status">
          <div
            className={`status_row_sticky d-none d-md-block  ${
              isFixed ? "is-fixed" : ""
            }`}
            ref={stickyRef}
          >
            {(isInitialLoad || activeStatuses.includes("CREATED")) && (
              <div className="status_item_box draft_status">
                <div className="status-heading">
                  <IconCircle size={18} stroke={5} color="#818183ff" />
                  <span className="fw-bold">Pending</span>
                </div>
                <span className="status_count" style={{ color: "#818183ff" }}>
                  {createdres?.pagination?.totalRmas}
                </span>
              </div>
            )}

            {(isInitialLoad || activeStatuses.includes("OPEN")) && (
              <div className="status_item_box pending_status">
                <div className="status-heading">
                  <IconCircle size={18} stroke={5} color="#f1a008ff" />
                  <span className="fw-bold">Active/Open</span>
                </div>
                <span className="status_count" style={{ color: "#f1a008ff" }}>
                  {openres?.pagination?.totalRmas}
                </span>
              </div>
            )}

            {(isInitialLoad || activeStatuses.includes("CLOSED")) && (
              <div className="status_item_box won_status">
                <div className="status-heading">
                  <IconCircle size={18} stroke={5} color="#06a159ff" />
                  <span className="fw-bold">Closed</span>
                </div>
                <span className="status_count" style={{ color: "#06a159ff" }}>
                  {closedres?.pagination?.totalRmas}
                </span>
              </div>
            )}

            {(isInitialLoad || activeStatuses.includes("CANCELLED")) && (
              <div className="status_item_box closed_status">
                <div className="status-heading">
                  <IconCircle size={18} stroke={5} color="#e72222" />
                  <span className="fw-bold">Cancelled</span>
                </div>
                <span className="status_count" style={{ color: "#e72222" }}>
                  {cancelledres?.pagination?.totalRmas}
                </span>
              </div>
            )}
          </div>

          <div
            className="stepper_status bs-stepper-header d-flex d-md-none"
            role="tablist"
          >
            {StatusList.map((step, idx) => (
              <div
                className={`step ${
                  currentStep === idx + 1
                    ? " active"
                    : idx + 1 < currentStep
                      ? "completed"
                      : ""
                }`}
                key={idx}
              >
                <button
                  onClick={() => handleTabClick(idx + 1)}
                  type="button"
                  className="step-trigger"
                  role="tab"
                >
                  <span className="bs-stepper-label d-flex align-items-center justify-content-between">
                    {step}
                    <span className="status_count ms-2">
                      {statusCounts[step] ?? 0}
                    </span>
                  </span>
                </button>
              </div>
            ))}
          </div>

          <div className="status_row_box">
            {(isInitialLoad || activeStatuses.includes("CREATED")) && (
              <div
                className={`status_row_scroll ${
                  currentStep === 1 ? "active_status_tab" : ""
                }  Created`}
              >
                <>
                  {createdData?.length > 0 ? (
                    createdData?.map((row, index) => (
                      <Card
                        className={`status_item_card  ${
                          highlightedOrders.includes(row.rma_id)
                            ? "card-highlight "
                            : ""
                        }`}
                        key={index}
                        onClick={() => handleViewClick(row)}
                        style={{ cursor: "pointer" }}
                      >
                        <Card.Body>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card d-flex gap-2 align-items-center">
                                RMA ID:{" "}
                                <p className="label_card listing_label">
                                  {row.rma_id}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">Order ID</div>
                              <p className="label_card">
                                {row?.order_id || "N/A"}
                              </p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">
                                Organization Name
                              </div>
                              <p className="label_card">
                                {row?.organization_name || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">RMA Type</div>
                              <p className="label_card">{row?.rma_type}</p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">Created Date</div>
                              <p className="label_card">
                                {moment(row?.created_at).format("MM/DD/YYYY")}
                              </p>
                            </div>
                          </div>

                          <div className="button-groups">
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(row);
                                }}
                              >
                                <IconEye size={24} />
                              </span>
                              <b> View Details </b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRMARVERSION_OPEN(e, row.rma_id);
                                }}
                              >
                                <IconHistoryToggle size={24} />
                              </span>
                              <b> Changes History</b>
                            </div>

                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  openModal(row.rma_id, "OPEN", "CREATED");
                                }}
                              >
                                <IconSquareArrowRight size={24} />
                              </span>
                              <b> Change Stage</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    order_id: row.rma_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email</b>
                            </div>
                          </div>
                          <div className="rfq_card_row mt-3 justify-content-center">
                            <div className="total_amt_rfq">
                              <strong>Total Cost:</strong>
                              <strong className="amt_bold">
                                ${row?.total_cost_after_margin}
                              </strong>
                            </div>
                          </div>
                          <div className="ftr_card_box">
                            <a
                              className="big_badge bg-cyan-lt"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/edit-rma/${row.rma_id}`);
                              }}
                            >
                              <IconEdit width={18} height={18} /> Edit
                            </a>
                            <div className="rfq_lis_short">
                              <span>
                                <IconBox stroke={1} />
                                {row.RmaProducts.length}
                              </span>
                              <span>
                                <IconPaperclip stroke={1} />
                                {row.Attachments.length}
                              </span>
                              <span>
                                <IconMessageCircle stroke={1} />
                                {row.section.reduce((acc, section) => {
                                  return acc + section.notes.length;
                                }, 0)}
                              </span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))
                  ) : (
                    <Card className="status_item_card">
                      <Card.Body>No data found.</Card.Body>
                    </Card>
                  )}
                </>

                {createdres?.data?.length >= 10 && hasMoreCreated && (
                  <div className="text-center mt-2">
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleLoadMoreCreated}
                      disabled={loadingCreated}
                    >
                      <IconRotateClockwise size={18} />
                      {loadingCreated ? "Loading..." : "Load More"}
                    </button>
                  </div>
                )}
              </div>
            )}

            {(isInitialLoad || activeStatuses.includes("OPEN")) && (
              <div
                className={`status_row_scroll ${
                  currentStep === 2 ? "active_status_tab" : ""
                }  Open`}
              >
                <>
                  {openData?.length > 0 ? (
                    openData?.map((row, index) => (
                      <Card
                        className={`status_item_card  ${
                          highlightedOrders.includes(row.rma_id)
                            ? "card-highlight "
                            : ""
                        }`}
                        key={index}
                        onClick={() => handleViewClick(row)}
                        style={{ cursor: "pointer" }}
                      >
                        <Card.Body>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card d-flex gap-2 align-items-center">
                                RMA ID:{" "}
                                <p className="label_card listing_label">
                                  {row.rma_id}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">Order ID</div>
                              <p className="label_card">
                                {row?.order_id || "N/A"}
                              </p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">
                                Organization Name
                              </div>
                              <p className="label_card">
                                {row?.organization_name || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">RMA Type</div>
                              <p className="label_card">{row?.rma_type}</p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">Created Date</div>
                              <p className="label_card">
                                {moment(row?.created_at).format("MM/DD/YYYY")}
                              </p>
                            </div>
                          </div>

                          <div className="button-groups">
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(row);
                                }}
                              >
                                <IconEye size={24} />
                              </span>
                              <b> View Details </b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRMARVERSION_OPEN(e, row.rma_id);
                                }}
                              >
                                <IconHistoryToggle size={24} />
                              </span>
                              <b> Changes History</b>
                            </div>

                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  openModal(row.rma_id, "CLOSED", "OPEN");
                                }}
                              >
                                <IconSquareArrowRight size={24} />
                              </span>
                              <b> Change Stage</b>
                            </div>

                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    order_id: row.rma_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email</b>
                            </div>
                          </div>
                          <div className="rfq_card_row mt-3 justify-content-center">
                            <div className="total_amt_rfq">
                              <strong>Total Cost:</strong>
                              <strong className="amt_bold">
                                ${row?.total_cost_after_margin || "0.00"}
                              </strong>
                            </div>
                          </div>
                          <div className="ftr_card_box">
                            <a
                              className="big_badge bg-cyan-lt"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/edit-rma/${row.rma_id}`);
                              }}
                            >
                              <IconEdit width={18} height={18} /> Edit
                            </a>
                            <div className="rfq_lis_short">
                              <span>
                                <IconBox stroke={1} />
                                {row.RmaProducts.length}
                              </span>
                              <span>
                                <IconPaperclip stroke={1} />
                                {row.Attachments.length}
                              </span>
                              <span>
                                <IconMessageCircle stroke={1} />
                                {row.section.reduce((acc, section) => {
                                  return acc + section.notes.length;
                                }, 0)}
                              </span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))
                  ) : (
                    <Card className="status_item_card">
                      <Card.Body>No data found.</Card.Body>
                    </Card>
                  )}
                </>

                {openres?.data?.length >= 10 && hasMoreOpen && (
                  <div className="text-center mt-2">
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleLoadMoreOpen}
                      disabled={loadingOpen}
                    >
                      <IconRotateClockwise size={18} />
                      {loadingOpen ? "Loading..." : "Load More"}
                    </button>
                  </div>
                )}
              </div>
            )}

            {(isInitialLoad || activeStatuses.includes("CLOSED")) && (
              <div
                className={`status_row_scroll ${
                  currentStep === 3 ? "active_status_tab" : ""
                }  Closed`}
              >
                <>
                  {closedData?.length > 0 ? (
                    closedData?.map((row, index) => (
                      <Card
                        className={`status_item_card  ${
                          highlightedOrders.includes(row.rma_id)
                            ? "card-highlight "
                            : ""
                        }`}
                        key={index}
                        onClick={() => handleViewClick(row)}
                        style={{ cursor: "pointer" }}
                      >
                        <Card.Body>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card d-flex gap-2 align-items-center">
                                RMA ID:{" "}
                                <p className="label_card listing_label">
                                  {row.rma_id}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">Order ID</div>
                              <p className="label_card">
                                {row?.order_id || "N/A"}
                              </p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">
                                Organization Name
                              </div>
                              <p className="label_card">
                                {row?.organization_name || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">RMA Type</div>
                              <p className="label_card">{row?.rma_type}</p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">Created Date</div>
                              <p className="label_card">
                                {moment(row?.created_at).format("MM/DD/YYYY")}
                              </p>
                            </div>
                          </div>

                          <div className="button-groups">
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(row);
                                }}
                              >
                                <IconEye size={24} />
                              </span>
                              <b> View Details </b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRMARVERSION_OPEN(e, row.rma_id);
                                }}
                              >
                                <IconHistoryToggle size={24} />
                              </span>
                              <b> Changes History</b>
                            </div>

                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  openModal(row.rma_id, "CANCELLED", "CLOSED");
                                }}
                              >
                                <IconSquareArrowRight size={24} />
                              </span>
                              <b> Change Stage</b>
                            </div>

                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    order_id: row.rma_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email</b>
                            </div>
                          </div>
                          <div className="rfq_card_row mt-3 justify-content-center">
                            <div className="total_amt_rfq">
                              <strong>Total Cost:</strong>
                              <strong className="amt_bold">
                                ${row?.total_cost_after_margin || "0.00"}
                              </strong>
                            </div>
                          </div>
                          <div className="ftr_card_box">
                            <a
                              className="big_badge bg-cyan-lt"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/edit-rma/${row.rma_id}`);
                              }}
                            >
                              <IconEdit width={18} height={18} /> Edit
                            </a>
                            <div className="rfq_lis_short">
                              <span>
                                <IconBox stroke={1} />
                                {row.RmaProducts.length}
                              </span>
                              <span>
                                <IconPaperclip stroke={1} />
                                {row.Attachments.length}
                              </span>
                              <span>
                                <IconMessageCircle stroke={1} />
                                {row.section.reduce((acc, section) => {
                                  return acc + section.notes.length;
                                }, 0)}
                              </span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))
                  ) : (
                    <Card className="status_item_card">
                      <Card.Body>No data found.</Card.Body>
                    </Card>
                  )}
                </>

                {closedres?.data?.length >= 10 && hasMoreClosed && (
                  <div className="text-center mt-2">
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleLoadMoreClosed}
                      disabled={loadingClosed}
                    >
                      <IconRotateClockwise size={18} />
                      {loadingClosed ? "Loading..." : "Load More"}
                    </button>
                  </div>
                )}
              </div>
            )}

            {(isInitialLoad || activeStatuses.includes("CANCELLED")) && (
              <div
                className={`status_row_scroll ${
                  currentStep === 4 ? "active_status_tab" : ""
                }  Cancelled`}
              >
                <>
                  {cancelledData?.length > 0 ? (
                    cancelledData?.map((row, index) => (
                      <Card
                        className={`status_item_card  ${
                          highlightedOrders.includes(row.rma_id)
                            ? "card-highlight "
                            : ""
                        }`}
                        key={index}
                        onClick={() => handleViewClick(row)}
                        style={{ cursor: "pointer" }}
                      >
                        <Card.Body>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card d-flex gap-2 align-items-center">
                                RMA ID:{" "}
                                <p className="label_card listing_label">
                                  {row.rma_id}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">Order ID</div>
                              <p className="label_card">
                                {row?.order_id || "N/A"}
                              </p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">
                                Organization Name
                              </div>
                              <p className="label_card">
                                {row?.organization_name || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">RMA Type</div>
                              <p className="label_card">{row?.rma_type}</p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">Created Date</div>
                              <p className="label_card">
                                {moment(row?.created_at).format("MM/DD/YYYY")}
                              </p>
                            </div>
                          </div>

                          <div className="button-groups">
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(row);
                                }}
                              >
                                <IconEye size={24} />
                              </span>
                              <b> View Details </b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRMARVERSION_OPEN(e, row.rma_id);
                                }}
                              >
                                <IconHistoryToggle size={24} />
                              </span>
                              <b> Changes History</b>
                            </div>

                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    order_id: row.rma_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email</b>
                            </div>
                          </div>
                          <div className="rfq_card_row mt-3 justify-content-center">
                            <div className="total_amt_rfq">
                              <strong>Total Cost:</strong>
                              <strong className="amt_bold">
                                ${row?.total_cost_after_margin || "0.00"}
                              </strong>
                            </div>
                          </div>
                          <div className="ftr_card_box">
                            <a
                              className="big_badge bg-cyan-lt"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/edit-rma/${row.rma_id}`);
                              }}
                            >
                              <IconEdit width={18} height={18} /> Edit
                            </a>
                            <div className="rfq_lis_short">
                              <span>
                                <IconBox stroke={1} />
                                {row.RmaProducts.length}
                              </span>
                              <span>
                                <IconPaperclip stroke={1} />
                                {row.Attachments.length}
                              </span>
                              <span>
                                <IconMessageCircle stroke={1} />
                                {row.section.reduce((acc, section) => {
                                  return acc + section.notes.length;
                                }, 0)}
                              </span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))
                  ) : (
                    <Card className="status_item_card">
                      <Card.Body>No data found.</Card.Body>
                    </Card>
                  )}
                </>

                {cancelledres?.data?.length >= 10 && hasMoreCancelled && (
                  <div className="text-center mt-2">
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleLoadMoreCancelled}
                      disabled={loadingCancelled}
                    >
                      <IconRotateClockwise size={18} />
                      {loadingCancelled ? "Loading..." : "Load More"}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </>
    </>
  );
};

export default RmaListing;
